/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
export class MgtPersonCardConfig {
}
MgtPersonCardConfig.sections = {
    files: true,
    mailMessages: true,
    organization: { showWorksWith: true },
    profile: true
};
MgtPersonCardConfig.useContactApis = true;
MgtPersonCardConfig.isSendMessageVisible = true;
